(() => {
  const comparisonSelector = '.homeax-before-after';
  const lazyVideoSelector = 'video[data-homeax-src], video source[data-homeax-src]';

  const initialise = (comparison) => {
    if (comparison.dataset.homeaxCompareReady === 'true') return;

    const range = comparison.querySelector('.homeax-before-after__range');
    if (!range) return;

    const update = () => {
      const position = Math.min(100, Math.max(0, Number(range.value) || 0));
      comparison.style.setProperty('--homeax-compare-position', `${position}%`);
    };

    range.addEventListener('input', update, { passive: true });
    range.addEventListener('change', update, { passive: true });
    update();
    comparison.dataset.homeaxCompareReady = 'true';
  };

  const activateVideo = (video) => {
    if (!video || video.dataset.homeaxVideoLoaded === 'true') return;

    const sources = video.querySelectorAll('source[data-homeax-src]');
    sources.forEach((source) => {
      source.src = source.dataset.homeaxSrc;
      source.removeAttribute('data-homeax-src');
    });

    if (video.dataset.homeaxSrc) {
      video.src = video.dataset.homeaxSrc;
      video.removeAttribute('data-homeax-src');
    }

    video.preload = 'none';
    video.dataset.homeaxVideoLoaded = 'true';
    video.load();
  };

  const initialiseLazyVideos = (root = document) => {
    const videos = new Set();

    if (root.matches?.(lazyVideoSelector)) {
      videos.add(root.matches('video') ? root : root.closest('video'));
    }

    root.querySelectorAll?.(lazyVideoSelector).forEach((element) => {
      videos.add(element.matches('video') ? element : element.closest('video'));
    });

    videos.forEach((video) => {
      if (!video || video.dataset.homeaxVideoObserved === 'true') return;

      video.preload = 'none';
      video.dataset.homeaxVideoObserved = 'true';

      if (!('IntersectionObserver' in window)) {
        activateVideo(video);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              activateVideo(video);
              video.play().catch(() => {});
            } else if (video.dataset.homeaxVideoLoaded === 'true') {
              video.pause();
            }
          });
        },
        { rootMargin: '120px 0px', threshold: 0.01 }
      );

      observer.observe(video);
    });
  };

  const initialiseAll = (root = document) => {
    if (root.matches?.(comparisonSelector)) initialise(root);
    root.querySelectorAll?.(comparisonSelector).forEach(initialise);
    initialiseLazyVideos(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
